import { compact } from 'lodash';
import { useMemo } from 'react';

import { Diagnosis } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { TableDataAccessor } from '@dreryk/react-components';

import { VisitStatusResolver } from '../../shared/VisitStatusResolver/VisitStatusResolver';

export const DiagnosisInformationTableDataAccessor: TableDataAccessor<Diagnosis> = (props) => {
   const visitIds = useMemo<number[]>(() => {
      return compact(props.currentPage.map((diagnosis) => diagnosis.visitId?.asNumber()));
   }, [props.currentPage]);

   return <VisitStatusResolver visitIds={visitIds} />;
};
